import script from "./orderBox.vue?vue&type=script&setup=true&lang=js"
export * from "./orderBox.vue?vue&type=script&setup=true&lang=js"

import "./orderBox.vue?vue&type=style&index=0&id=cdb8fef4&lang=scss&scoped=true"

import exportComponent from "D:\\GProjects\\MsSaj\\pms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb8fef4"]])

export default __exports__